import React, { useEffect } from "react"
import { observer } from "mobx-react-lite"
import styled from "~/ui/styled"
import { Button, CenterFlex, ColumnFlex, Text } from "~components/El"
import { useTheme } from "~/ui/styled"
import { useStores } from "~models"
import type { NoticeItem } from "./notice-center-context"
import rechargeSuccessHeader from "~assets/images/notice/recharge-success-header.png"

/** 原图 321×60，装饰区约占上方 52px；白条与弹窗顶边重叠量 */
const HEADER_DECORATION_RATIO = 52 / 321
const HEADER_OVERLAP = 16

const CardRoot = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
  margin-top: calc(100% * ${HEADER_DECORATION_RATIO} - ${HEADER_OVERLAP}px);
`

const HeaderWrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(100% - ${HEADER_OVERLAP}px);
  z-index: 2;
  line-height: 0;
  pointer-events: none;
`

const HeaderImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  user-select: none;
`

const CardShell = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  background: ${({ theme }) => theme.colors.blockBackground};
  border-radius: 0 0 20px 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`

const Body = styled(ColumnFlex)`
  width: 100%;
  align-items: center;
  padding: 12px 24px 24px;
`

const AmountRow = styled(CenterFlex)`
  margin-top: 20px;
  gap: 6px;
`

const Coin = styled(CenterFlex)`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background: #ff3b30;
  flex-shrink: 0;
`

function parseRechargeAmount(item: NoticeItem) {
  const fromExtra = item.extra?.amount ?? item.extra?.money
  if (fromExtra != null && fromExtra !== "") return String(fromExtra)
  const text = `${item.content ?? ""} ${item.label ?? ""}`
  const match = text.match(/[+＋]?\s*[¥￥]?\s*([\d,.]+)/)
  return match ? match[1].replace(/,/g, "") : "0"
}

export function isRechargeNotice(item: NoticeItem) {
  if (![1, 3].includes(Number(item.type))) return false
  const text = `${item.label ?? ""}${item.content ?? ""}`
  return text.includes("充值")
}

type Props = {
  item: NoticeItem
  onConfirm: () => void
}

const NoticeRechargeSuccessCard: React.FC<Props> = ({ item, onConfirm }) => {
  const theme = useTheme()
  const { walletStore } = useStores()
  const amount = parseRechargeAmount(item)

  useEffect(() => {
    walletStore.getWalletInfo()
  }, [walletStore])

  return (
    <CardRoot>
      <HeaderWrap aria-hidden>
        <HeaderImage src={rechargeSuccessHeader} alt="" draggable={false} />
      </HeaderWrap>
      <CardShell>
        <Body height="auto">
          <Text fontSize="18px" fontWeight="600" color={theme.colors.primary}>
            充值成功
          </Text>
          <AmountRow height="auto" width="auto">
            <Text fontSize="40px" fontWeight="700" color={theme.colors.text}>
              +{amount}
            </Text>
            <Coin>
              <Text fontSize="14px" fontWeight="700" color="#fff">
                ¥
              </Text>
            </Coin>
          </AmountRow>
          <Text mt="12px" fontSize="14px" color={theme.colors.secondaryText}>
            您的账户余额：¥{walletStore.balance ?? "0.00"}
          </Text>
          <Button
            width="100%"
            height="44px"
            mt="28px"
            borderRadius="22px"
            bg={theme.colors.primary}
            onClick={onConfirm}
          >
            <Text color={theme.colors.blockBackground} fontWeight="600">
              我知道了
            </Text>
          </Button>
        </Body>
      </CardShell>
    </CardRoot>
  )
}

export default observer(NoticeRechargeSuccessCard)
